import { render, staticRenderFns } from "./LedgerRow.vue?vue&type=template&id=4219f9f0&scoped=true&"
import script from "./LedgerRow.vue?vue&type=script&lang=js&"
export * from "./LedgerRow.vue?vue&type=script&lang=js&"
import style0 from "./LedgerRow.vue?vue&type=style&index=0&id=4219f9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219f9f0",
  null
  
)

export default component.exports